import React from 'react';
import { CalendarDaysIcon, ExternalLinkIcon } from 'lucide-react';
export function RegistrationCallout() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1208">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-1209">
        <div className="flex flex-col p-6 rounded-xl mb-12 shadow-sm" style={{
        backgroundColor: '#1e3d2f'
      }} data-id="element-1210">
          <div className="flex items-center gap-4 mb-3" data-id="element-1211">
            <CalendarDaysIcon size={24} className="flex-shrink-0" style={{
            color: '#c8a84b'
          }} data-id="element-1212" />
            <a href="https://www.fentonlakes.com/m7/41--michigan-concealed-pistol-course-cpl-renewal-class.html" target="_blank" rel="noopener noreferrer" className="text-base font-semibold transition-colors hover:underline" style={{
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1213">
              Click here to select class date and to register
            </a>
            <ExternalLinkIcon size={20} className="flex-shrink-0" style={{
            color: '#a0c8b0'
          }} data-id="element-1214" />
          </div>
          <p className="text-sm ml-10" style={{
          color: '#a0c8b0',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-1215">
            FLSC members must log in to receive Membership Discount rate.
            Discount will show up when you add the class to your cart.
          </p>
        </div>
      </div>
    </div>;
}